import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestService } from '../../request-service/request.service';
import { RequestChatMessage, WithRequestChat } from './request-chat.model';

/**
 * Chat di una richiesta CAREGIVER_CONSULT, lato staff. Non esiste un GET dedicato: i messaggi sono nel campo
 * `chat` della richiesta, quindi per rileggerli si ricarica la richiesta. Scrivere, modificare ed eliminare
 * sono gli endpoint `/v2/requests/{requestId}/chat` (la Web App può solo scrivere).
 */
@Injectable({ providedIn: 'root' })
export class RequestChatService {
  private readonly baseUrl = `${environment.baseURL.replace(/\/v1$/, '/v2')}/requests`;

  constructor(private http: HttpClient, private requestService: RequestService) {}

  /** Messaggi e stato correnti della richiesta, letti dalla richiesta stessa (campo `chat` e stato operativo). */
  getChat(requestId: number): Observable<{ messages: RequestChatMessage[]; status: string | null }> {
    return this.requestService.getRequestByID(String(requestId)).pipe(
      map((request) => ({
        messages: (request as unknown as WithRequestChat).chat ?? [],
        status: request.operationalInfo?.status ?? null,
      }))
    );
  }

  setRequestStatus(requestId: number, status: string): Observable<unknown> {
    return this.requestService.changeStatus(requestId, status);
  }

  send(requestId: number, message: string): Observable<RequestChatMessage> {
    return this.http.post<RequestChatMessage>(`${this.baseUrl}/${requestId}/chat`, { message });
  }

  /** Risponde 200 senza dettagli sul messaggio: chi chiama aggiorna il testo in locale. */
  edit(requestId: number, messageId: string, message: string): Observable<unknown> {
    return this.http.put(`${this.baseUrl}/${requestId}/chat/${messageId}`, { message });
  }

  /** Risponde 204 senza corpo. */
  delete(requestId: number, messageId: string): Observable<unknown> {
    return this.http.delete(`${this.baseUrl}/${requestId}/chat/${messageId}`);
  }
}
